import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { generatePath, Redirect } from 'react-router-dom'

import { AppRoute } from 'routing/AppRoute.enum'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { useGetPulseSurveys } from 'hooks/pulseSurveys/useGetPulseSurveys'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

import { NoSurveys } from './NoSurveys'
import { Templates } from './Templates'
import * as S from './blank.styles'

export const Blank = () => {
    const { activePulseSurvey } = usePulseSurveys()

    const { isLoading } = useGetPulseSurveys()

    if (isLoading) {
        return (
            <S.BlankWrapper data-testid="pulse-surveys-blank-skeleton">
                <Skeleton variant="rect" width="100%" />

                <Skeleton variant="rect" width="100%" />
            </S.BlankWrapper>
        )
    }

    if (activePulseSurvey) {
        return (
            <Redirect
                to={generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: activePulseSurvey.uuid }))}
            />
        )
    }

    return (
        <S.BlankWrapper>
            <NoSurveys />

            <Templates />
        </S.BlankWrapper>
    )
}
